import { render, staticRenderFns } from "./ArticleUpload.vue?vue&type=template&id=1c9b906c&scoped=true"
import script from "./ArticleUpload.vue?vue&type=script&lang=js"
export * from "./ArticleUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9b906c",
  null
  
)

export default component.exports